import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Margin, Text } from 'shared/components'

import { ConfirmForm } from './components/confirmForm'
import * as styles from './styles'

const ConfirmPasswordComponent = ({ initialValues, onSubmit }) => (
  <Grid>
    <Row center="sm">
      <Col xs={12} sm={6} lg={4}>
        <Margin top={4} resetWhen="phone">
          <section css={styles.confirmSection}>
            <Margin as="section" bottom={2}>
              <Text as="h2" size={24}>
                Confirm Password
              </Text>
            </Margin>
            <section>
              <Text block maxCh={30}>
                Your can change your password here.
              </Text>
            </section>
            <Margin as="section" tb={2}>
              <ConfirmForm initialValues={initialValues} onSubmit={onSubmit} />
            </Margin>
          </section>
        </Margin>
      </Col>
    </Row>
  </Grid>
)

ConfirmPasswordComponent.propTypes = {
  initialValues: PropTypes.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ConfirmPasswordComponent
